<script setup lang="ts">
import InteractiveTopics from "~/components/InteractiveTopics.vue";
import PageContainer from "~/components/ui/PageContainer.vue";
import DataTypesPreview from "~/features/python/ch2/data-types/components/DataTypesPreview.vue";
import DataTypesQuiz from "~/features/python/ch2/data-types/components/DataTypesQuiz.vue";
import DataTypesTable from "~/features/python/ch2/data-types/components/DataTypesTable.vue";
import TypeConversion from "~/features/python/ch2/data-types/components/TypeConversion.vue";
import TypeDetector from "~/features/python/ch2/data-types/components/TypeDetector.vue";
import { buildComputerCollectionSchema } from "~/features/computer/data/seo/computer-schema";
import { pythonInteractiveCards } from "~/features/python/data/chapter2-interactive";

const relatedCards = pythonInteractiveCards.filter((item) => item.to !== "/11th/computer/python/data-types/");

usePageSeo({
  title: "Chapter 2 Python Data Types | Ustaad",
  description: "Chapter 2 Python data types with examples, type checking, important MCQ concepts and quick revision for class 11 students.",
  keywords: "chapter 2 python data types, python data types class 11, 11th class computer data types, first year computer python data types",
  breadcrumbs: [
    { name: "Home", item: "/" },
    { name: "11th Computer", item: "/11th/computer/" },
    { name: "Ch 2 Python", item: "/11th/computer/python/" },
    { name: "Data Types", item: "/11th/computer/python/data-types/" },
  ],
  schemaType: "CollectionPage",
  schemaProperties: buildComputerCollectionSchema({
    about: "Chapter 2 Python Data Types",
    items: [
      { name: "Chapter 2 Python", path: "/11th/computer/python/" },
      { name: "Chapter 2 Python Variables", path: "/11th/computer/python/variables/" },
      { name: "Chapter 2 Python MCQs", path: "/11th/computer/python/mcqs/" },
      { name: "Chapter 2 Python Short Questions", path: "/11th/computer/python/short-questions/" },
      { name: "Chapter 2 Python Programs", path: "/11th/computer/python/programs/" },
    ],
  }),
});
</script>

<template>
  <PageContainer>
    <div class="space-y-8">
      <section class="rounded-3xl bg-slate-950 p-6 text-white">
        <p class="text-xs font-semibold uppercase tracking-[0.18em] text-sky-300">Python Chapter 2</p>
        <h1 class="mt-2 text-2xl font-bold tracking-tight">Chapter 2 Python Data Types</h1>
        <p class="mt-3 text-sm leading-7 text-slate-200">
          Yahan aap samjhoge ke Python kis cheez ko number samajhta hai, kis cheez ko text samajhta hai, aur kis cheez ko true ya false samajhta hai.
        </p>
      </section>

      <section class="grid gap-6 lg:grid-cols-[1.1fr_0.9fr]">
        <TypeDetector />
        <DataTypesQuiz />
      </section>

      <TypeConversion />

      <DataTypesTable />
      <DataTypesPreview />

      <InteractiveTopics
        eyebrow="More Python Topics"
        title="More Python Topics"
        intro="Data types ke baad baqi important Python topics bhi yahan se khol sakte hain."
        :cards="relatedCards"
      />
    </div>
  </PageContainer>
</template>
